namespace SorAraBul.PropertyManagement {
    export namespace TenantDetailPanelService {
        export const baseUrl = 'PropertyManagement/TenantDetailPanel';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TenantDetailPanelRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "PropertyManagement/TenantDetailPanel/Retrieve"
        }

        [
            'Retrieve'
        ].forEach(x => {
            (<any>TenantDetailPanelService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
